module.exports = __webpack_public_path__ + "img/tb_web.b9642c32.jpg";